import { useOrganizationStore } from '@/core/stores/organization.store';
import { useOrganizations } from './useOrganizations';

export function useActiveOrganization() {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);
  const setActiveOrganization = useOrganizationStore((s) => s.setActiveOrganization);
  const { data: organizations = [] } = useOrganizations();

  const activeOrganization = organizations.find((org) => org.id === activeOrganizationId) ?? null;

  return {
    activeOrganization,
    setActiveOrganization,
    organizations,
    activeOrganizationId,
  };
}
